"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { id: "load-game" };
const _hoisted_2 = { class: "load-game-form load-game--block" };
const _hoisted_3 = { class: "container load-game-options" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("h1", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.APP_NAME), 1)
            ])), [
                [_directive_i18n]
            ]),
            _cache[3] || (_cache[3] = (0, vue_1.createTextVNode)(" — ", -1)),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[2] || (_cache[2] = [
                    (0, vue_1.createTextVNode)("Load Game", -1)
                ]))])), [
                [_directive_i18n]
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                (0, vue_1.createElementVNode)("div", null, [
                    _cache[4] || (_cache[4] = (0, vue_1.createElementVNode)("label", { for: "gameId" }, "Game, player, or spectator ID to reload:", -1)),
                    _cache[5] || (_cache[5] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        class: "form-input form-inline load-game-id",
                        placeholder: 'Game Id',
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.gameId) = $event))
                    }, null, 512), [
                        [vue_1.vModelText, _ctx.gameId]
                    ]),
                    _cache[6] || (_cache[6] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                    _cache[7] || (_cache[7] = (0, vue_1.createElementVNode)("label", { for: "rollbackCount" }, "Number of saves to delete before loading:", -1)),
                    _cache[8] || (_cache[8] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        class: "form-input form-inline load-game-id",
                        value: "0",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.rollbackCount) = $event))
                    }, null, 512), [
                        [vue_1.vModelText, _ctx.rollbackCount]
                    ]),
                    _cache[9] || (_cache[9] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                    (0, vue_1.createVNode)(_component_AppButton, {
                        title: "Load Game",
                        size: "big",
                        type: "success",
                        onClick: _ctx.loadGame
                    }, null, 8, ["onClick"])
                ])
            ])
        ])
    ]));
}
